import { AncillaryOption } from '@eti/schema-types';
import { getPriceProps } from '../../common/utils/productCardProps';
export const AirportDirection = {
  From: 0,
  To: 1,
  None: 2,
  Both: 3
};
export const isDistribusionChoice = choice => {
  return choice != null && 'externalChoiceId' in choice && 'pricePerTravelers' in choice;
};
export const withoutNulls = () => item => item != null;
export const findTransferBound = (bounds, direction) => bounds.find(bound => {
  var _bound$boundAndSegmen, _bound$boundAndSegmen2;
  return direction === AirportDirection.From ? ((_bound$boundAndSegmen = bound.boundAndSegmentIndices) === null || _bound$boundAndSegmen === void 0 ? void 0 : _bound$boundAndSegmen.boundIndex) === 1 : ((_bound$boundAndSegmen2 = bound.boundAndSegmentIndices) === null || _bound$boundAndSegmen2 === void 0 ? void 0 : _bound$boundAndSegmen2.boundIndex) === 2;
});
const getAirportDirectionType = operatorBound => {
  var _operatorBound$, _operatorBound$2;
  if (!operatorBound) {
    return AirportDirection.None;
  }
  if ((operatorBound === null || operatorBound === void 0 ? void 0 : operatorBound.length) > 1) {
    return AirportDirection.Both;
  }
  if ((operatorBound === null || operatorBound === void 0 ? void 0 : operatorBound.length) === 1 && ((_operatorBound$ = operatorBound[0]) === null || _operatorBound$ === void 0 ? void 0 : _operatorBound$.boundIndex) === 1) {
    return AirportDirection.From;
  }
  if ((operatorBound === null || operatorBound === void 0 ? void 0 : operatorBound.length) === 1 && ((_operatorBound$2 = operatorBound[0]) === null || _operatorBound$2 === void 0 ? void 0 : _operatorBound$2.boundIndex) === 2) {
    return AirportDirection.To;
  }
  return AirportDirection.None;
};
const findFirstUrl = text => {
  const urlRegex = /https?:\/\/[^\s/$.?#][^\s"']*/;
  const match = text.match(urlRegex);
  return match ? match[0] : null;
};
export const getOperatorList = (t, isSelected, product, sellSpecification) => {
  var _sellSpecification$ex;
  return sellSpecification === null || sellSpecification === void 0 || (_sellSpecification$ex = sellSpecification.externalChoices) === null || _sellSpecification$ex === void 0 ? void 0 : _sellSpecification$ex.map(exChoice => {
    var _exChoice$distribusio, _exChoice$pricePerTra, _exChoice$pricePerTra2, _operatorData$0$trans, _operatorData$0$terms, _operatorData$;
    if (!isDistribusionChoice(exChoice)) {
      return null;
    }
    const operatorData = (_exChoice$distribusio = exChoice.distribusionChoiceBoundData.filter(withoutNulls())) !== null && _exChoice$distribusio !== void 0 ? _exChoice$distribusio : [];
    if (!exChoice || !operatorData || operatorData.length === 0) {
      return null;
    }
    const priceRaw = (_exChoice$pricePerTra = (_exChoice$pricePerTra2 = exChoice.pricePerTravelers[0]) === null || _exChoice$pricePerTra2 === void 0 || (_exChoice$pricePerTra2 = _exChoice$pricePerTra2.price) === null || _exChoice$pricePerTra2 === void 0 || (_exChoice$pricePerTra2 = _exChoice$pricePerTra2.price) === null || _exChoice$pricePerTra2 === void 0 ? void 0 : _exChoice$pricePerTra2.value) !== null && _exChoice$pricePerTra !== void 0 ? _exChoice$pricePerTra : 0;
    const {
      price
    } = getPriceProps(t, isSelected, {
      ...product,
      priceRaw
    });
    const airportDirection = getAirportDirectionType(operatorData.map(choiceData => choiceData === null || choiceData === void 0 ? void 0 : choiceData.boundAndSegmentIndices));
    const {
      transferCarrier,
      transferType
    } = operatorData[0];
    const transferTime = airportDirection === AirportDirection.Both ? operatorData.map(choice => {
      var _choice$transferTime;
      return (_choice$transferTime = choice.transferTime) !== null && _choice$transferTime !== void 0 ? _choice$transferTime : 0;
    }).reduce((a, b) => a + b, 0) / 2 : (_operatorData$0$trans = operatorData[0].transferTime) !== null && _operatorData$0$trans !== void 0 ? _operatorData$0$trans : 0;
    const termsAndConditions = findFirstUrl((_operatorData$0$terms = (_operatorData$ = operatorData[0]) === null || _operatorData$ === void 0 ? void 0 : _operatorData$.termsAndConditions) !== null && _operatorData$0$terms !== void 0 ? _operatorData$0$terms : '');
    const transferBoundData = operatorData.map(operator => {
      return {
        arrivalDateTime: operator === null || operator === void 0 ? void 0 : operator.arrivalDateTime,
        departureDateTime: operator === null || operator === void 0 ? void 0 : operator.departureDateTime,
        arrivalStation: operator === null || operator === void 0 ? void 0 : operator.arrivalStation,
        departureStation: operator === null || operator === void 0 ? void 0 : operator.departureStation,
        boundAndSegmentIndices: operator === null || operator === void 0 ? void 0 : operator.boundAndSegmentIndices,
        termsAndConditions,
        validityDuration: operator === null || operator === void 0 ? void 0 : operator.validityDuration,
        validityDurationType: operator === null || operator === void 0 ? void 0 : operator.validityDurationType,
        validityReferenceTimeType: operator === null || operator === void 0 ? void 0 : operator.validityReferenceTimeType
      };
    });
    return {
      ancillaryOption: exChoice.ancillaryOption,
      transferTime,
      externalChoiceId: exChoice.externalChoiceId,
      transferCarrier,
      transferType,
      price,
      priceRaw,
      airportDirection,
      transferBoundData
    };
  }).filter(withoutNulls());
};
export const sortOperatorList = operatorList => {
  const hasCheapest = operatorList.length > 1 && operatorList[0].priceRaw !== operatorList[1].priceRaw;
  return hasCheapest ? operatorList : operatorList.map(operator => ({
    ...operator,
    ancillaryOption: (operator === null || operator === void 0 ? void 0 : operator.ancillaryOption) === AncillaryOption.Cheapest ? undefined : operator.ancillaryOption
  })).sort((a, b) => {
    var _a$transferTime, _b$transferTime;
    return ((_a$transferTime = a.transferTime) !== null && _a$transferTime !== void 0 ? _a$transferTime : 0) - ((_b$transferTime = b.transferTime) !== null && _b$transferTime !== void 0 ? _b$transferTime : 0);
  });
};
const formatTravelTime = (value, unitSingular, unitPlural) => {
  if (value > 0) {
    const unit = value > 1 ? unitPlural : unitSingular;
    return `${value} ${unit}`;
  }
  return '';
};
const hoursInSeconds = 3600;
export const convertToHoursAndMinutes = (totalSeconds, hourSingularText, hourPluralText, minuteSingularText, minutePluralText, transferTimeTranslation) => {
  const hours = Math.floor(totalSeconds / hoursInSeconds);
  const minutes = Math.round((totalSeconds - hours * hoursInSeconds) / 60);
  return `${formatTravelTime(hours, hourSingularText, hourPluralText)} ${formatTravelTime(minutes, minuteSingularText, minutePluralText)} ${transferTimeTranslation}`;
};
export const ValidityReferenceTimeType = {
  Unknown: 'Unknown',
  PurchaseTime: 'Purchase time',
  BeginningOfDepartureDay: 'Beginning of departure day',
  DepartureTime: 'Departure time',
  BeginningOfPurchaseDay: 'Beginning of purchase day'
};
export const ValidityDurationType = {
  Unknown: 'eras',
  Months: 'months',
  Days: 'days',
  Hours: 'hours',
  Minutes: 'minutes'
};
const DurationUnit = {
  Month: 'month',
  Months: 'months',
  Hour: 'hour',
  Hours: 'hours',
  Minute: 'minute',
  Minutes: 'minutes',
  Day: 'day',
  Days: 'days'
};
const durationUnits = {
  [ValidityDurationType.Months]: [DurationUnit.Month, DurationUnit.Months],
  [ValidityDurationType.Hours]: [DurationUnit.Hour, DurationUnit.Hours],
  [ValidityDurationType.Minutes]: [DurationUnit.Minute, DurationUnit.Minutes],
  [ValidityDurationType.Days]: [DurationUnit.Day, DurationUnit.Days]
};
const getDurationUnitText = (duration, durationType, translation) => {
  var _durationUnits$durati;
  const [singular, plural] = (_durationUnits$durati = durationUnits[durationType]) !== null && _durationUnits$durati !== void 0 ? _durationUnits$durati : durationUnits[ValidityDurationType.Days];
  return translation[duration === 1 ? singular : plural];
};
const hasValidDuration = bound => Boolean(bound.validityDuration && bound.validityDurationType && bound.validityDurationType !== ValidityDurationType.Unknown);
export const ValidityKind = {
  Open: 'open',
  TimeSpecific: 'timeSpecific',
  Fallback: 'fallback'
};
export const getValidityKindForBound = bound => {
  if (!(bound !== null && bound !== void 0 && bound.validityReferenceTimeType)) {
    return ValidityKind.Fallback;
  }
  const {
    validityReferenceTimeType
  } = bound;
  const isDepartureTime = validityReferenceTimeType === ValidityReferenceTimeType.DepartureTime;
  const isUnknownReference = validityReferenceTimeType === ValidityReferenceTimeType.Unknown;
  const hasDuration = hasValidDuration(bound);
  const isOpen = !isDepartureTime && !isUnknownReference && hasDuration;
  const isTimeSpecific = isDepartureTime && !hasDuration;
  if (isOpen) {
    return ValidityKind.Open;
  }
  if (isTimeSpecific) {
    return ValidityKind.TimeSpecific;
  }
  return ValidityKind.Fallback;
};
export const getValidityKind = operator => {
  var _operator$transferBou;
  return getValidityKindForBound((_operator$transferBou = operator.transferBoundData) === null || _operator$transferBou === void 0 ? void 0 : _operator$transferBou[0]);
};
export const isOpenTicket = operator => getValidityKind(operator) === ValidityKind.Open;
export const isTimeSpecificTicket = operator => getValidityKind(operator) === ValidityKind.TimeSpecific;
export const getCardValidityText = (operator, translation) => {
  switch (getValidityKind(operator)) {
    case ValidityKind.Open:
      return translation.validAnyDeparture;
    case ValidityKind.Fallback:
      return translation.validityInEmail;
    default:
      return null;
  }
};
export const getDrawerValidityTextForBound = (bound, translation) => {
  if (!bound || getValidityKindForBound(bound) !== ValidityKind.Open) {
    return null;
  }
  const {
    validityReferenceTimeType,
    validityDurationType,
    validityDuration
  } = bound;
  if (!validityDuration || !validityDurationType) {
    return null;
  }
  if (validityReferenceTimeType === ValidityReferenceTimeType.BeginningOfDepartureDay) {
    return translation.validAnyDeparture;
  }
  const unitText = getDurationUnitText(validityDuration, validityDurationType, translation);
  return `${translation.validFor} ${validityDuration} ${unitText} ${translation.fromPurchase}`;
};
export const NoneOption = 'NONE';
//# sourceMappingURL=utils.js.map